module.exports = __webpack_public_path__ + "static/media/114.37b484b5.webp";